import { ChipPassThroughOptions } from 'primereact/chip';
import { classNames } from 'primereact/utils';

export const PTChip: ChipPassThroughOptions = {
  root: {
    className: classNames(
      'inline-flex items-center font-medium gap-2',
      'rounded-[16px] px-3',
    ),
  },
  label: { className: 'leading-6 mt-1.5 mb-1.5' },
  icon: { className: 'leading-6 mr-2' },
  image: {
    className: classNames('w-9 h-9 ml-[-0.75rem] mr-2', 'rounded-full'),
  },
  removeIcon: {
    className: classNames(
      'ml-2 rounded-md transition duration-200 ease-in-out',
      'cursor-pointer leading-6',
    ),
  },
};
